// File: frontend/src/components/utility/PageTransition.js

import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const PageTransition = ({ children }) => {
  const [isTransitioning, setIsTransitioning] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsTransitioning(true);
    const timer = setTimeout(() => {
      setIsTransitioning(false);
    }, 50);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  if (isTransitioning) {
    return <div className="page-transition-placeholder"></div>;
  }

  return <>{children}</>;
};

export default PageTransition;